import axios from 'axios';
import { env } from '@shared/config/env';
import {
  categoryFromVehicleDataDto,
  modelFromVehicleDataDto,
  brandFromVehicleDataDto,
  vehicleInfoFromDto,
} from '@features/vehicles/mappers/vehiclesMapper';

const vehicleDataApi = axios.create({
  baseURL: env.URL_VEHICLE_DATA_SERVICE,
  timeout: 10000,
});

vehicleDataApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const normalized = new Error(
      status >= 400 && status < 500
        ? 'No se encontró la información solicitada.'
        : 'Error en el servicio de vehículos. Intente de nuevo.',
    );
    normalized.status = status;
    normalized.original = error;
    return Promise.reject(normalized);
  },
);

export const getCategories = async () => {
  const response = await vehicleDataApi.get('/categories');
  return response.data.map(categoryFromVehicleDataDto);
};

export const getModels = async ({ categoryId, stateId }) => {
  const response = await vehicleDataApi.get('/models', {
    params: { category_id: categoryId, state_id: stateId },
  });
  return response.data.map(modelFromVehicleDataDto);
};

export const getBrandsFromDataService = async ({ categoryId, stateId, modelId }) => {
  const response = await vehicleDataApi.get('/brands', {
    params: { category_id: categoryId, state_id: stateId, model_id: modelId },
  });
  return response.data.map(brandFromVehicleDataDto);
};

export const searchVehicles = async ({ brandId, modelId, categoryId, stateId }) => {
  const response = await vehicleDataApi.get('/vehicles/search', {
    params: { brand_id: brandId, model_id: modelId, category_id: categoryId, state_id: stateId },
  });
  return response.data.map(vehicleInfoFromDto);
};

export const getVehicleByCode = async (code) => {
  const response = await vehicleDataApi.get(`/vehicles/${code}`);
  return vehicleInfoFromDto(response.data);
};
